const ACTION_TITLES = Object.freeze({
  view: "Consulter",
  create: "Créer",
  create_payment: "Créer un paiement",
  edit_payment: "Modifier un paiement",
  delete_payment: "Supprimer un paiement",
  edit: "Modifier",
  delete: "Supprimer",
  approve: "Approuver",
  export: "Exporter",
  import: "Importer",
  generate: "Générer",
  generate_pdf: "Générer le PDF",
  manage: "Gérer",
  view_payments: "Voir les paiements associés",
  assign_invoice_number: "Saisir un numéro de facture à la création",
  correct_invoice_number: "Corriger un numéro de facture existant",
});

const PATH_TITLES = Object.freeze({
  logistics: "Logistique",
  "logistics.customer_payments": "Paiements Entrants",
  "logistics.supplier_payments": "Paiements Sortants fournisseurs",
  "logistics.expenses": "Charges Admin",
  "logistics.expenses.entries": "Saisie et paiements des charges",
  "Admin.Magasins": "Établissements",
  "Gestion Commerciale.Stock.GestionStock": "Gestion du stock",
  "Gestion Commerciale.Stock.GestionStock.History": "Historique des stocks",
  "Gestion Commerciale.Stock.GestionStock.Transfer": "Transferts de stock",
  "Gestion Commerciale.Stock.GestionStock.Adjust": "Ajustements de stock",
  "Gestion Commerciale.Ventes.PaiementsEntrants": "Encaissements clients",
  "Gestion Commerciale.Approvisionnement.Achats.PaiementsSortants":
    "Paiements fournisseurs",
});

const PERMISSION_TITLES = Object.freeze({
  "Gestion Commerciale.Stock.GestionStock.History.view":
    "Consulter l'historique des stocks",
  "Gestion Commerciale.Stock.GestionStock.Transfer.view":
    "Consulter les transferts de stock",
  "Gestion Commerciale.Stock.GestionStock.Transfer.create":
    "Créer un transfert de stock",
  "Gestion Commerciale.Stock.GestionStock.Transfer.edit":
    "Modifier un transfert de stock",
  "Gestion Commerciale.Stock.GestionStock.Transfer.delete":
    "Supprimer un transfert de stock",
  "Gestion Commerciale.Stock.GestionStock.Adjust.view":
    "Consulter les ajustements de stock",
  "Gestion Commerciale.Stock.GestionStock.Adjust.create":
    "Créer un ajustement de stock",
  "Gestion Commerciale.Stock.GestionStock.Adjust.edit":
    "Modifier un ajustement de stock",
  "Gestion Commerciale.Stock.GestionStock.Adjust.delete":
    "Supprimer un ajustement de stock",
  "Gestion Commerciale.Ventes.Ventes.view_payments":
    "Voir les règlements associés aux ventes",
  "Gestion Commerciale.Ventes.PaiementsEntrants.view":
    "Consulter le registre des encaissements",
  "Gestion Commerciale.Ventes.PaiementsEntrants.create":
    "Enregistrer un encaissement client",
  "Gestion Commerciale.Ventes.PaiementsEntrants.edit":
    "Modifier un encaissement client",
  "Gestion Commerciale.Ventes.PaiementsEntrants.delete":
    "Supprimer un encaissement client",
  "Gestion Commerciale.Approvisionnement.Achats.Achat.view_payments":
    "Voir les règlements associés aux achats",
  "Gestion Commerciale.Approvisionnement.Achats.PaiementsSortants.view":
    "Consulter le registre des paiements fournisseurs",
  "Gestion Commerciale.Approvisionnement.Achats.PaiementsSortants.create":
    "Enregistrer un paiement fournisseur",
  "Gestion Commerciale.Approvisionnement.Achats.PaiementsSortants.edit":
    "Modifier un paiement fournisseur",
  "Gestion Commerciale.Approvisionnement.Achats.PaiementsSortants.delete":
    "Supprimer un paiement fournisseur",
});

const humanizePermissionPart = (part) =>
  String(part || "")
    .replace(/([a-z0-9])([A-Z])/g, "$1 $2")
    .replace(/_/g, " ")
    .replace(/^./, (character) => character.toUpperCase())
    .trim();

export const getPermissionPartTitle = (part, currentPath) =>
  PERMISSION_TITLES[currentPath] ||
  PATH_TITLES[currentPath] ||
  ACTION_TITLES[part] ||
  humanizePermissionPart(part);

export const getPermissionListLabel = (permissionKey) => {
  const parts = String(permissionKey || "").split(".").filter(Boolean);
  if (parts.length === 0) return "";

  const action = parts.pop();
  const actionPath = [...parts, action].join(".");
  const actionTitle = getPermissionPartTitle(action, actionPath);
  const subjectParts = parts.slice(1);
  const subject = subjectParts
    .map((part, index) =>
      getPermissionPartTitle(part, parts.slice(0, index + 2).join("."))
    )
    .join(" · ");

  return subject ? `${actionTitle} — ${subject}` : actionTitle;
};

export const PERMISSION_ACTION_ORDER = Object.freeze([
  "view",
  "view_payments",
  "create",
  "create_payment",
  "edit",
  "edit_payment",
  "approve",
  "delete",
  "delete_payment",
  "import",
  "export",
]);

export const comparePermissionTreeNodes = (left, right) => {
  const leftPart = String(left?.key || "").split(".").pop();
  const rightPart = String(right?.key || "").split(".").pop();
  const leftRank = PERMISSION_ACTION_ORDER.indexOf(leftPart);
  const rightRank = PERMISSION_ACTION_ORDER.indexOf(rightPart);

  if (leftRank >= 0 || rightRank >= 0) {
    if (leftRank < 0) return -1;
    if (rightRank < 0) return 1;
    if (leftRank !== rightRank) return leftRank - rightRank;
  }

  return String(left?.title || "").localeCompare(
    String(right?.title || ""),
    "fr",
    { sensitivity: "base" }
  );
};
